// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"813dfb14","458":"02902e3f","540":"87149208","776":"be4bbc6c","858":"6c0ae1d0"}[chunkId] + ".chunk.css";
};